import "@babel/polyfill";
import "whatwg-fetch";
import React from "react";
import { render } from "react-dom";
import getQuery from "@zendesk/knowledge-utils/lib/PageNavigator/getQuery";
import t from "@zendesk/client-i18n-tools";
import analytics from "@zendesk/knowledge-analytics";
import connect from "@zendesk/knowledge-connect";
import App from "components/App";
import navigate from "@zendesk/knowledge-utils/lib/PageNavigator/navigate";
import history from "utils/history";
import isDirty from "utils/isDirty";
import clearState from "utils/clearState";
import { getParams, getRoute, setBrandId } from "utils/navigation";
import canAccessVerification from "utils/canAccessVerification";

import { loadContext } from "@zendesk/knowledge-context";

import "@zendeskgarden/css-bedrock/dist/index.css";
import "@zendeskgarden/react-avatars/dist/styles.css";
import "@zendeskgarden/react-buttons/dist/styles.css";
import "@zendeskgarden/react-menus/dist/styles.css";
import "@zendeskgarden/react-modals/dist/styles.css";
import "@zendeskgarden/react-pagination/dist/styles.css";
import "@zendeskgarden/react-radios/dist/styles.css";
import "@zendeskgarden/react-select/dist/styles.css";
import "@zendeskgarden/react-tables/dist/styles.css";
import "@zendeskgarden/react-tags/dist/styles.css";
import "@zendeskgarden/react-textfields/dist/styles.css";

import "styles/global.css";

const query = getQuery();

const renderApp = location => {
  const route = getRoute();

  if (route === "index" || route === "new") {
    clearState();
  }

  render(
    <App route={route} params={getParams()} />,
    document.getElementById("container")
  );
};

// Make sure a brand with a help center is selected.
// If brand_id in the query is not valid or is not set
// pick the agent brand or a first suitable brand
loadContext({ brandId: query.brand_id }).then(context => {
  if (!canAccessVerification(context)) {
    return navigate("/hc/admin/general_settings");
  }

  const hasBrandId = "brand_id" in query;

  if (!hasBrandId) {
    setBrandId();
  }

  t.load(context.token.user.locale, () => {
    document.title = t("knowledge-verification.name");

    renderApp(history.location);
    history.listen(renderApp);

    window.onbeforeunload = evt => {
      if (isDirty()) {
        return t("knowledge-verification.discardConfirmation");
      }
    };

    history.block((location, action) => {
      if (location.state && location.state.skipDirtyCheck) return true;

      const route = getRoute();

      if (["new", "edit", "duplicate"].includes(route) && isDirty()) {
        return t("knowledge-verification.discardConfirmation");
      }
    });

    setTimeout(() => {
      analytics.setup();
      connect.setup();
    }, 1000);
  });
});



// WEBPACK FOOTER //
// ./src/index.js